import axios from "axios";
import { urls } from "../model/constants";

export const onRemoveBook = async (uidList: string[]) => {
  return new Promise<void>((resolve, reject) => {
    axios({
      url: urls.onRemoveBook,
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        book_uid: uidList,
      },
    })
      .then((result) => {
        if (result.status === 200) {
          const data = result.data;
          if (data.status !== "success") throw "error";

          resolve();
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
